document.addEventListener('DOMContentLoaded', function() {
  // Delegate for all add-on ATC buttons
  document.body.addEventListener('click', async function(event) {
    const btn = event.target.closest('.product-add-on__button');
    if (!btn) return;

    event.preventDefault();
    if (btn.disabled) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Save original button content (HTML)
    const originalContent = btn.innerHTML;

    // Insert spinner
    btn.innerHTML = '<span class="atc-spinner" aria-hidden="true"></span>';
    btn.disabled = true;

    try {
      // Add to cart (mimic ProductBundle.addItemToCart)
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || errorData.message || 'Error adding to cart');
      }

      // Update cart drawer using the custom element's renderContents method
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        fetch('/?sections=cart-drawer')
          .then(res => res.json())
          .then(data => {
            const parsedState = {
              sections: {
                'cart-drawer': data['cart-drawer']
              }
            };
            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
            }
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          })
          .catch(() => cartDrawer.open && cartDrawer.open());
      } else {
        window.location.href = '/cart';
      }

      // Optionally update cart count bubble
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartCountBubble = document.querySelector('.cart-count-bubble span');
          if (cartCountBubble) cartCountBubble.textContent = cart.item_count;
        });

      // Show checkmark
      btn.innerHTML = '<span class="atc-checkmark" aria-hidden="true"></span>';
      setTimeout(() => {
        btn.innerHTML = originalContent;
        btn.disabled = false;
      }, 1200);

    } catch (error) {
      btn.innerHTML = originalContent;
      btn.disabled = false;
      alert(error.message || 'Error adding to cart');
    }
  });
});
